import * as actions from './actions';
import Axios from 'axios';
import { getFilters } from './multi';

export const attemptAuth = (email, password) => {
  // receives changes as a object, the index of the changes, and the item to query
  return (dispatch, getState) => {
    dispatch(authLoading(true));
    Axios.post('/api/auth', {email, password})
    .then(response => {
      if(response.data.code === 200){
        dispatch(getFilters(response.data.user));
        dispatch(setAuth(true, response.data.user));
      } else {
        dispatch(setAuth(false));
        dispatch(authLoading(false));
        dispatch(authError(response.data.error || 'Unable to process request'));
      }
    })
    .catch(err => {
      dispatch(setAuth(false));
      dispatch(authLoading(false));
      dispatch(authError('Unable to process request'));
    })
  };
};

export const attemptSignUp = (email, password, confirmPassword, code) => {
  return (dispatch, getState) => {
    if(!email || !password || !confirmPassword || !code){
      dispatch(authError('Ensure all fields are filled.'))
    };
    if(password !== confirmPassword){
      dispatch(authError('Your passwords do not match.'))
    }
    Axios.post('/api/auth/sign-up', {email, password, code})
    .then(response => {
      if(response.data.code === 200){
        dispatch(attemptAuth(email, password));
      } else {
        // display the error from server;
        dispatch(authError(response.data.error))
      }
    })
    .catch(error =>  {
      dispatch(authError('Unable to process request'))
    })
    // dispatch(authLoading(true));
  }
};

export const setAuth = (authenticated, user) => ({
  type: actions.AUTH_SET,
  authenticated,
  user
});

export const authError = (error) => ({
  type: actions.AUTH_ERROR,
  error
});

export const authMessage = (message) => ({
  type: actions.AUTH_MESSAGE,
  message
})

export const authLoading = (loading) => ({
  type: actions.AUTH_LOADING,
  loading
});


// WEBPACK FOOTER //
// ./src/store/actions/auth.js